/* global FB*/
import React from 'react'
import {
  setFacebookPopup,
  logoutFb,
  fetchFaceBasedJson,
  facebookProfile,
  fbLogoutPopup,
  setRegPage
} from '../../action/action'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { fbCheckStatus, logoutM } from '../../components/shared/facebookOauthMobile'
import { checkStatus, logout } from '../../components/shared/facebookOauth'
import { instaStatusCheck } from '../../components/shared/instagramOauth'
import { twitterOauth } from '../../components/shared/twitterOauth'
import { popupColorSet } from '../../JS/setColors'
import { setLoginRequired } from '../../layout2.0/action/homeAction';

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileImage: null,
    }
  }

  onNoClick = () => {
    this.props.setFacebookPopup(false);
  }

  onContinueClick = () => {
    let date = new Date();
    let birthyear, age
    let img, userData, sentJson, interval, count = 0
    let fbCheck = localStorage.getItem("FB_user_info");
    if (fbCheck && fbCheck !== "null") {
      fbCheck = JSON.parse(fbCheck);
    } else {
      fbCheck = ""
    }
    if (fbCheck && fbCheck.name) {
      console.log("we have facebook data");
    } else {
      if (window.cordova) {
        userData = fbCheckStatus();
        console.log("return user Data", userData);
        interval = setInterval(() => {
          count++;
          if (count > 360) {
            window.clearInterval(interval);
          }
          console.log("we are in facebook interval");
          img = localStorage.getItem("user_profile");
          if (img && img !== "null") {
            window.clearInterval(interval);
            userData = localStorage.getItem("FB_user_info");
            userData = JSON.parse(userData);
            this.props.facebookProfile(img);
            if (userData && userData.gender && userData.birthday) {
              birthyear = parseInt(userData.birthday.slice(6, 10));
              age = (date.getFullYear()) - birthyear;
              console.log("user Data", userData, userData.birthday, userData.gender);
              sentJson = {
                "age": `${age ? age : 42}`,
                "classificationType": "Leisure",
                "gender": `${userData.gender ? userData.gender : "male"}`,
              }
              this.props.fetchFaceBasedJson(JSON.stringify(sentJson));
              this.setState({ profileImage: img });
            }
            this.props.logoutFb(!this.props.fbStatus);
            //this.props.getClientConfig("/deviceConfig");
          }
        }, 500);
      } else {
        userData = checkStatus();
        console.log("return user Data", userData);
        interval = setInterval(() => {
          count++;
          if (count > 20) {
            window.clearInterval(interval);
          }
          console.log("we are in facebook interval");
          img = localStorage.getItem("user_profile");
          if (img && img !== "null") {
            window.clearInterval(interval);
            this.setState({ profileImage: img });
            userData = localStorage.getItem("FB_user_info");
            userData = JSON.parse(userData);
            this.props.facebookProfile(img);
            if (userData && userData.gender && userData.birthday) {
              birthyear = parseInt(userData.birthday.slice(6, 10));
              age = (date.getFullYear()) - birthyear;
              console.log("user Data", userData, userData.birthday, userData.gender);
              sentJson = {
                "age": `${age ? age : 42}`,
                "classificationType": "Leisure",
                "gender": `${userData.gender ? userData.gender : "male"}`,
              }
              this.props.fetchFaceBasedJson(JSON.stringify(sentJson));
              this.setState({ profileImage: img });
            }
            this.props.logoutFb(!this.props.fbStatus);
          }
        }, 500);
      }
      this.props.logoutFb(!this.props.fbStatus);
    }
    this.props.setFacebookPopup(false);
  }

  onInstagramClick = () => {
    //instaStatusCheck();
    if(process.env.REACT_APP_INROOMTAB == "true") {
      this.props.setLoginRequired(true)
    } else {
      this.props.setRegPage(true);
    }
    this.props.setFacebookPopup(false);
  }

  onTwitterClick = () => {
    twitterOauth();
    this.props.setFacebookPopup(false);
  }

  onLogoutClick = (index) => {
    this.props.fbLogoutPopup(true);
    this.props.setFacebookPopup(false);
  }
  componentDidMount() {
    popupColorSet(this.props.menuColor);
  }

  render() {
    let fbData = localStorage.getItem("FB_user_info");
    return (
      <div class="overlay">
        <div id="svc" className="overlay-body">
          <div className="overlay-close" onClick={this.onNoClick}>
            <i class="fa fa-close" style={{ color: "inherit" }}></i>
          </div>
          {/*
            <button
              className="fb-button-margin"
              style={{
                alignContent: "center",
                width: "220px",
                height: "30px",
                textAlign: "center",
                color: "white",
                backgroundColor: "#4267b2",
                borderRadius: "2px",
                border: "none",
                fontFamily: "Helvetica, Arial, 'lucida grande',tahoma,verdana,arial,sans-serif",
                fontSize: "14px",
                padding: 0
              }}
              onClick={!fbData || fbData === "null" ? this.onContinueClick : this.onLogoutClick}>
              <img
                style={{ width: "30px", height: "28px", marginRight: "5px" }}
                src={require("../../images/f-ogo_RGB_HEX-58.svg")} />
              {!fbData || fbData === "null" ? "Log in with Facebook" : "Logout"}
            </button>
          }
          {
            
            <button
              className="fb-button-margin"
              style={{
                alignContent: "center",
                width: "220px",
                height: "30px",
                textAlign: "center",
                color: "white",
                backgroundColor: "#38A1F3",
                borderRadius: "2px",
                border: "none",
                fontFamily: "Helvetica, Arial, 'lucida grande',tahoma,verdana,arial,sans-serif",
                fontSize: "14px",
                marginTop: "10px"
              }}
              onClick={this.onTwitterClick}>
              <img
                style={{ width: "23px", height: "21px", marginRight: "5px" }}
                src={require("../../images/icon/twitter.svg")} />
              Log in with twitter
              </button>
            */
          }
          {
            <button className="popUpForSocialMediaLoing"
              style={{
                alignContent: "center",
                width: "220px",
                height: "30px",
                textAlign: "center",
                color: "white",
                backgroundColor: `${this.props.menuColor.assetBackgroundSelectorColor ?
                  this.props.menuColor.assetBackgroundSelectorColor : "#83ab3f"}`,
                borderRadius: "2px",
                border: "none",
                fontFamily: "Helvetica, Arial, 'lucida grande',tahoma,verdana,arial,sans-serif",
                fontSize: "14px",
                marginTop: "10px",
                padding: 0
              }}
              onClick={this.onInstagramClick}>
              Connect to your Room
            </button>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    callFacebookPopup: state.store.callFacebookPopup,
    stringConst: state.store.home.stringConst,
    menuColor: state.store.home.MenuColor
  }
}

export default connect(
  mapStateToProps,
  {
    setFacebookPopup,
    logoutFb,
    fetchFaceBasedJson,
    facebookProfile,
    fbLogoutPopup,
    setLoginRequired,
    setRegPage
  }
)(Popup);

/*
              <img
                style={{ width: "23px", height: "21px", marginRight: "5px" }}
                src={require("../../images/icon/instagram.svg")} />
              Continue with Instagram
*/